import { Routes } from "../routes"
import { NextRouter } from "next/router"

export const handleRedirect = async (username: string, router: NextRouter) => {
  let path
  const { redirect } = router.query

  if (typeof redirect === "string") {
    path = redirect
  } else {
    path = router.asPath
  }

  const isJoin = path === `${Routes.Join}`
  const isLogin = path === `${Routes.Login}`
  const isRoot = path === `${Routes.Homepage}`

  // if we are coming in from the homepage, login or join page: redirect to the user's profile page
  // otherwise go to redirect path
  if (isJoin || isLogin || isRoot) {
    await router.push({ pathname: "/[username]", query: { username } })
  } else {
    await router.push({ pathname: path })
  }
}
